import { showNotification } from './NotificationUtils';
import { isInvalidToken, logout } from './TokenUtils';

const urlBase = process.env.REACT_APP_API_URL;

export async function request(path, parameters) {
    let responseData;

    try {
        const token = localStorage.getItem('access_token');

        const response = await fetch(`${urlBase}${path}`, {
            method: parameters.type,
            body: parameters.body,
            headers: { 'Content-Type': 'application/json', 'Authorization': `Bearer ${token}` }
        });

        //necessário clone, pois se parameters.readMethod for blob por exemplo, pode não conseguir ler erros, que retornam em json
        const responseClone = response.clone();
        try {
            responseData = parameters?.readMethod ? await response[parameters.readMethod]() : await response.json();
        } catch (err) {

        }

        if (400 == response.status) {
            const errorJson = await responseClone.json();
            throw new Error(errorJson.error)
        }

        if (401 == response.status) {
            if (!isInvalidToken()) {
                throw new Error("Sem acesso ao recurso, solicite ao administrador.")
            }

            logout();
            return;
        }

        if (403 == response.status) {
            throw new Error("Sem acesso ao recurso, solicite ao administrador.")
        }

        if (!response.ok) {
            throw new Error("Erro ao buscar os dados.")
        }

        

        parameters.callback && parameters.callback(responseData);
        // Atualiza o estado com os dados recebidos
    } catch (err) {
        parameters.callbackError && parameters.callbackError(responseData, err.message);
    } finally {
        parameters.finally && parameters.finally();
    }
}


export async function handleErrors(responseData, message, errorStates = {}) {
    const errorsEmpty = !responseData?.errors || Object.keys(responseData?.errors).length === 0;

    if (!errorsEmpty && errorStates.setError) {
        errorStates.setError(responseData.errors);
    }

    if (responseData?.handledError) {
        if (!errorsEmpty) {
            Object.entries(responseData?.errors).forEach(([key, value]) => {

                showNotification(value, 'error', 5000);
                errorStates.setFetchListError && errorStates.setFetchListError(value);
            });
        }
        else if (responseData?.error) {
            errorStates.setFetchListError && errorStates.setFetchListError(responseData?.error);
            showNotification(responseData.error, 'error', 5000);
        }

    } else {
        errorStates.setFetchListError && errorStates.setFetchListError(message);
        showNotification(message, 'error', 3500);
    }
}